/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface HospitalizationGetPrintLightHtml$Params {

/**
 * filter criteria
 */
  insurerId?: string;

/**
 * filter criteria
 */
  cardId?: string;

/**
 * filter criteria
 */
  hospitalizationId?: number;

/**
 * filter criteria
 */
  languageCode?: string;

/**
 * filter criteria
 */
  messageId?: number;
}

export function hospitalizationGetPrintLightHtml(http: HttpClient, rootUrl: string, params?: HospitalizationGetPrintLightHtml$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, hospitalizationGetPrintLightHtml.PATH, 'get');
  if (params) {
    rb.query('insurerId', params.insurerId, {});
    rb.query('cardId', params.cardId, {});
    rb.query('hospitalizationId', params.hospitalizationId, {});
    rb.query('languageCode', params.languageCode, {});
    rb.query('messageId', params.messageId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<string>;
    })
  );
}

hospitalizationGetPrintLightHtml.PATH = '/v1/Hospitalization/GetPrintLightHTML';
